import React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import styled from "styled-components";
import Paper from "../components/ui-library/Paper/Paper";
import history from "../modules/history";
import { isStudyEnrolled } from "../modules/login";
import { getUnauthorizedStudyStatus } from "../modules/utils";

const StyledHeading = styled.div`
  font-size: 2.5rem;
  @media (max-width: 1024px) {
    font-size: 1.5rem;
  }
`;

const AccessDenied = (props) => {
  const { studies } = props;

  const { t } = useTranslation();

  useEffect(() => {
    if (studies) {
      const studyId = studies[0]?.studyId?.toLowerCase();

      if (
        isStudyEnrolled(studyId, studies, getUnauthorizedStudyStatus(studyId))
      ) {
        history.push("/study");
      }
    }
  }, [studies]);

  return (
    <div id="content" className="container-fluid">
      <div className="row">
        <Paper header={t("appText.accessDenied.title")}>
          <div
            className="h-100 w-100 d-flex flex-column align-items-center justify-content-center"
            style={{ minHeight: 400 }}
          >
            <StyledHeading>
              {t("appText.accessDenied.message", {
                study: studies && studies[0]?.code,
              })}
            </StyledHeading>
            <div>{t("appText.accessDenied.info")}</div>
          </div>
        </Paper>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    loginReducer: { studies },
  } = state;
  return { studies: studies };
};

export default connect(mapStateToProps, {})(AccessDenied);
